/**
 * ลมยก (updrafts) on the new Yanyu (plan B, data/layouts/yanyu2.ts; docs/systems/FUN_P1.md section 1): the falls pool, behind
 * the island shrine, the south feet of three crags, and the sea wind at the harbour mouth. Map metres (x east, y south);
 * `top` is the height in metres above the sea. The hidden master's spire (300, 40) is added with its secret (FUN R2).
 * Read by systems/wind.ts (`ZONE_UPDRAFTS`).
 */
import type { Updraft } from '../qinggong';

export const YANYU2_UPDRAFTS: readonly Updraft[] = [
  { id: 'yanyu2.falls', x: 384, y: 14, r: 14, top: 34, lift: 6 },
  { id: 'yanyu2.shrine', x: 402, y: 396, r: 8, top: 22, lift: 5 },
  { id: 'yanyu2.crag.mist-peak', x: 100, y: 130, r: 10, top: 96, lift: 7 },
  { id: 'yanyu2.crag.lantern-road', x: 523, y: 164, r: 12, top: 92, lift: 7 },
  { id: 'yanyu2.crag.cinnabar', x: 570, y: 202, r: 10, top: 86, lift: 7 },
  { id: 'yanyu2.harbour', x: 300, y: 556, r: 16, top: 18, lift: 4 },
];
